import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import { createGtm } from '@gtm-support/vue-gtm'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { es } from 'vuetify/locale'

import App from './App.vue'
import router from './router'
import { vMaska } from 'maska/vue'
import { initDatadog } from './services/datadog'



const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi'
  },
  components,
  directives,
  locale: {
    locale: 'es',
    fallback: 'es',
    messages: { es }
  }
})

const app = createApp(App)

app.directive('maska', vMaska)

initDatadog()

Sentry.init({
  app,
  dsn: import.meta.env.SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', 'https://vack.vaitty.com.ar/'],
  // Session Replay
  replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.use(
  createGtm({
    id: import.meta.env.VITE_GTM_ID,
    vueRouter: router
  })
)

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
